import Router from 'next/router';

import { Spacer, makeStyles } from '@bequestinc/wui';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles()(theme => ({
  withPadding: {
    padding: theme.spacing(2),
  },
  text: {
    fontSize: 15,
  },
}));

interface PropTypes {
  onClick?: Function;
  buttonColor?: string;
  returnToHome?: boolean;
  className?: string;
}

const BackButton = ({ onClick, buttonColor, returnToHome, ...props }: PropTypes) => {
  const { classes } = useStyles();

  const goBack = () => {
    if (onClick) {
      onClick();
      return;
    }
    if (returnToHome) {
      Router.replace('/');
    } else {
      Router.back();
    }
  };

  return (
    <Button variant="text" onClick={goBack} className={classes.withPadding} {...props}>
      <ArrowBackIcon fontSize="small" />
      <Spacer h={4} />
      <Typography className={classes.text} color={buttonColor}>
        {returnToHome ? 'Home' : 'Back'}
      </Typography>
    </Button>
  );
};

BackButton.defaultProps = {
  onClick: null,
  buttonColor: '',
  className: '',
  returnToHome: false,
};

export default BackButton;
